<template>
	<div>
		<BaseHeader :title="$t('overview').toString()" />
		<div class="main" v-if="!isLoading">
			<BaseCard :title="$t('open_broker_cases').toString()">
				<template #afterTitle>
					<BaseSelect
						ref="yearBaseSelect"
						v-model="selectedBrokerFilter"
						:multiple="false"
						:options="brokerFilters"
						:filter-only="true"
						class="w-72"
						style="padding-right: 0px!important; padding-bottom: 0px!important;"
						:label="$t('filter')"
						@changed="getBrokerCases"
				/></template>
				<div class="flex flex-col mb-10">
					<div class="w-full align-middle shadow overflow-x-auto border border-gray-200 rounded">
						<table v-if="brokerCases.length > 0" class="w-full table-fixed">
							<thead class="w-full" style="height: fit-content;">
								<tr class="">
									<HeaderColumn>{{ $t('date') }}</HeaderColumn>
									<HeaderColumn>{{ $t('license_plate_opponent') }}</HeaderColumn>
									<HeaderColumn>{{ $t('customer') }}</HeaderColumn>
									<!--									<HeaderColumn>{{ $t('imd_net_id') }}</HeaderColumn>-->
									<HeaderColumn>{{ $t('status') }}</HeaderColumn>
								</tr>
							</thead>
							<tbody class="bg-white">
								<tr
									v-for="(brokerCase, index) in brokerCases"
									:key="brokerCase.id"
									class="tr odd:bg-gray-200 w-full cursor-pointer"
									@click="redirectToBrokerCaseDetail(brokerCase.id)"
								>
									<td class="px-4 py-4" :class="brokerCase.length !== index + 1 ? 'border-b border-gray-200' : ''">
										<div>{{ brokerCase.created_at != null ? getGermanDate(new Date(brokerCase.created_at)) : $t('no_data') }}</div>
									</td>
									<td class="py-4" :class="brokerCase.length !== index + 1 ? 'border-b border-gray-200' : ''">
										{{ brokerCase.causer_license_plate ?? $t('no_data') }}
									</td>
									<td class="py-4" :class="brokerCase.length !== index + 1 ? 'border-b border-gray-200' : ''">
										{{ brokerCase.first_name }} {{ brokerCase.last_name }}
									</td>
									<!--									<td class="py-4" :class="brokerCase.length !== index + 1 ? 'border-b border-gray-200' : ''">-->
									<!--										{{ brokerCase.reference_number ?? $t('no_data') }}-->
									<!--									</td>-->
									<td class="py-4" :class="brokerCase.length !== index + 1 ? 'border-b border-gray-200' : ''">
										{{ getBrokerCaseStatus(brokerCase.status) }}
									</td>
								</tr>
							</tbody>
						</table>
						<div class="min-w-full p-4" v-else>
							{{ $t('no_entries_found') }}
						</div>
					</div>
				</div>
			</BaseCard>
		</div>
		<LoadingSpinner v-else />
	</div>
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import BaseCard from '@/components/damagecases/forms/BaseCard';
import Authentication from '@/mixins/Authentication';
import HeaderColumn from '@/components/columns/HeaderColumn.vue';
import DamageAssessorCaseRepository from '@/api/repositories/DamageAssessorCaseRepository';
import { getBrokerCaseStatus } from '@/helpers/Utils';
import router from '@/router';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import { getGermanDate } from '../../plugins/Utils';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';

export default {
	name: 'BrokerCaseOverview',
	components: {
		BaseSelect,
		LoadingSpinner,
		HeaderColumn,
		BaseCard,
		BaseHeader,
	},
	mixins: [Authentication],
	data() {
		return {
			isLoading: false,
			per_page: { display: '25', value: 25 },
			damageAssessorCases: [],
			brokerCases: [],
			brokerFilters: [
				{ value: 'all', display: 'Alle' },
				{ value: 'declined', display: 'Abgelehnte' },
			],
			selectedBrokerFilter: null,
			queryFilter: [
				{ value: 'all', display: 'Alle' },
				{ value: 'own_open', display: 'Eigene Offene' },
				{ value: 'own_closed', display: 'Eigene Geschlossene' },
			],
			selectedFilter: null,
		};
	},
	mounted() {
		this.isLoading = true;
		this.selectedBrokerFilter = this.brokerFilters[0];
		this.getBrokerCases();
	},
	methods: {
		getGermanDate,
		getBrokerCaseStatus,
		getBrokerCases() {
			if (this.selectedBrokerFilter === this.brokerFilters[0]) {
				new DamageAssessorCaseRepository()
					.getBrokerCases()
					.then(response => {
						this.brokerCases = response.data;
						this.isLoading = false;
					})
					.catch(e => {
						console.log(e);
					});
			} else {
				new DamageAssessorCaseRepository()
					.getDeclinedCases()
					.then(response => {
						this.brokerCases = response.data;
						this.isLoading = false;
					})
					.catch(e => {
						console.log(e);
					});
			}
		},
		getAllCases() {
			new DamageAssessorCaseRepository()
				.getAllCases(this.selectedFilter.value)
				.then(response => {
					this.damageAssessorCases = response.data;
					this.isLoading = false;
				})
				.catch(e => {
					console.log(e);
				});
		},
		redirectToBrokerCaseDetail(id) {
			router.push({ name: 'brokerCaseDetail', params: { id: id } });
		},
		redirectToDamageAssessorDetail(id) {
			router.push({ name: 'damageAssessorCaseDetail', params: { id: id } });
		},
	},
};
</script>
